//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapState } from "vuex";
import { debounce } from "quasar";
import AQModalDlg from "@/components/Generics/AQModalDlg/AQModalDlg.vue";
import icons from "./icons.json";
import { vuesaxIcons } from "./icons-vuesax";

export default {
    name: "QfMIcons",
    components: { AQModalDlg },
    props: {
        selection: { type: String, default: "" }
    },
    data() {
        return {
            iconsax: [],
            localIconSax: [],
            selectedTab: "tab-material",
            selected: { ligature: null, name: null },
            filter: "",
            localShow: true,
            icons: [],
            localIcons: [],
            thumb: {
                right: "-5px", borderRadius: "4px", width: "5px", opacity: 0.3
            },
            loaded: false,
            loadedSax: false
        };
    },
    computed: {
        ...mapState("components", ["parsed"]),
        disable() {
            return this.selected.name === null;
        },
        actions() {
            return [{ label: "Select", name: "select", disable: this.disable }];
        },
        getMaterialLabel() {
            return this.filter && this.filter.trim() ? `Material ${this.localIcons.length}` : "Material";
        },
        getVuesaxLabel() {
            return this.filter && this.filter.trim() ? `Vuesax ${this.localIconSax.length}` : "Vuesax";
        }
    },
    watch: {
        filter() {
            this.filterFn();
        }
    },
    created() {
        this.filterFn = debounce(this.filterFn, 300);
        const checkSelected = () => (vuesaxIcons.find(icon => icon === this.selection));
        if (this.selection && checkSelected()) {
            this.selectedTab = "tab-vuesax";
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.refSearchInput && this.$refs.refSearchInput.$el) {
                this.$refs.refSearchInput.$el.click();
            }
        });
    },
    methods: {
        modalAction(action) {
            if (action.simple === "hide") {
                this.localShow = false;
            } else if (action.simple === "action") {
                if (action.detailed === "select") {
                    this.$emit("update", this.selected.name);
                    this.localShow = false;
                }
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        modalAfterShow() {
            this.$nextTick(() => {
                Object.entries(icons).forEach(([key, value]) => {
                    if (this.selection && (key === this.selection)) {
                        this.selected = { ligature: value, name: key };
                        this.icons.unshift({ ...this.selected });
                    } else {
                        this.icons.push({ ligature: value, name: key });
                    }
                });
                vuesaxIcons.forEach(icon => {
                    if (this.selection && (icon === this.selection)) {
                        this.selected = { ligature: icon, name: icon };
                        this.iconsax.unshift({ ...this.selected });
                    } else {
                        this.iconsax.push({ ligature: icon, name: icon });
                    }
                });

                this.localIcons = this.icons;
                this.localIconSax = this.iconsax;
                this.$nextTick(() => {
                    this.loaded = true;
                    this.loadedSax = true;
                });
            });
        },
        filterFn() {
            if (this.filter) {
                const getIcons = (v) => (v.filter(icon => icon.name.toLowerCase().includes(this.filter.toLowerCase())));
                this.localIcons = getIcons(this.icons);
                this.localIconSax = getIcons(this.iconsax);
            } else {
                this.localIcons = this.icons;
                this.localIconSax = this.iconsax;
            }
        },
        onClick(icon) {
            this.selected = icon;
        }
    }
};
